module.exports = __webpack_public_path__ + "img/goldregen-2020-046.4f63b28d.jpg";